import jquery from 'jquery';
import angular from 'angular';
import 'hammerjs';
import './vendors/angular-hammer';
window.$ = window.jQuery = jquery;
window.angular = angular;
